import { defineMessages } from 'react-intl';

/** The copy of the unlock cards and the preview line (design: onboarding c5). Product copy, not ASD-STE100. */
export const unlockMessages = defineMessages({
  audioTitle: { id: 'app.sml.firstRelease.unlock.audio.title', defaultMessage: 'Add the audio → videos' },
  audioBody: {
    id: 'app.sml.firstRelease.unlock.audio.body',
    defaultMessage: 'Unlocks AI reels, short videos, the canvas loop and the visualizer.',
  },
  audioAction: { id: 'app.sml.firstRelease.unlock.audio.action', defaultMessage: 'Add audio' },
  lyricsTitle: { id: 'app.sml.firstRelease.unlock.lyrics.title', defaultMessage: 'Add the lyrics → lyric cards' },
  lyricsBody: {
    id: 'app.sml.firstRelease.unlock.lyrics.body',
    defaultMessage: 'Unlocks lyric cards, lyric stories and the lyric video.',
  },
  lyricsAction: { id: 'app.sml.firstRelease.unlock.lyrics.action', defaultMessage: 'Add lyrics' },
  done: { id: 'app.sml.firstRelease.unlock.done', defaultMessage: 'Done' },
  releaseDayTag: { id: 'app.sml.firstRelease.releaseDay.tag', defaultMessage: 'Pre-save' },
  releaseDayBody: {
    id: 'app.sml.firstRelease.releaseDay.body',
    defaultMessage: 'Add the release day to get your pre-save page. Fans can then save the song before it is out.',
  },
  releaseDayAction: { id: 'app.sml.firstRelease.releaseDay.action', defaultMessage: 'Add the release day' },
  firstImages: { id: 'app.sml.firstRelease.firstImages', defaultMessage: 'Your first images' },
  // QA 2026-10-28 (lit-8): name the unit. The count is images (files), not the kit parts of the summary.
  firstImagesCount: {
    id: 'app.sml.firstRelease.firstImages.countImages',
    defaultMessage: '{count, plural, one {# image} other {# images}} on the way · about a minute',
  },
});
